import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getVendorPoDataAsync,
  getVendorPoTrendDataAsync,
} from 'src/services/costModelling/skuShouldCostWorkbench.services'
import { formatNumber } from 'src/utils/Functions/aggridUtils/customValueFormatter'

const initialState = {
  getPoVendorData: {
    getpoTrendsLoader: false,
    getpoTrendsData: [],
    getpoTrendsError: '',
  },
  getVendorPoTrendData: {
    getpoTrendsLineChartLoader: false,
    getpoTrendsLineChartData: [],
    getpoTrendsLineChartError: '',
  },
}

export const getVendorPoData = createSlice({
  name: 'get-po-trends-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getVendorPoDataAsync.pending), (state) => {
      state.getPoVendorData.getpoTrendsLoader = true
    })
    builder.addMatcher(isAnyOf(getVendorPoDataAsync.fulfilled), (state, action) => {
      state.getPoVendorData.getpoTrendsLoader = false
      state.getPoVendorData.getpoTrendsData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getVendorPoDataAsync.rejected), (state, action) => {
      state.getPoVendorData.getpoTrendsLoader = false
      state.getPoVendorData.getpoTrendsError = action?.payload?.message
    })
    builder.addMatcher(isAnyOf(getVendorPoTrendDataAsync.pending), (state) => {
      state.getVendorPoTrendData.getpoTrendsLineChartLoader = true
    })
    builder.addMatcher(isAnyOf(getVendorPoTrendDataAsync.fulfilled), (state, action) => {
      state.getVendorPoTrendData.getpoTrendsLineChartLoader = false
      const formattedPOTrendsLineChartData = action.payload.data?.map((obj) => {
        return { ...obj, formattedValueY: formatNumber(obj.cost) }
      })
      state.getVendorPoTrendData.getpoTrendsLineChartData = formattedPOTrendsLineChartData
    })
    builder.addMatcher(isAnyOf(getVendorPoTrendDataAsync.rejected), (state, action) => {
      state.getVendorPoTrendData.getpoTrendsLineChartLoader = false
      state.getVendorPoTrendData.getpoTrendsLineChartError = action?.payload?.message
    })
  },
  reducers: {
    resetVendorPoData: (state) => {
      state.getPoVendorData = initialState.getPoVendorData
    },
    resetVendorPoTrendData: (state) => {
      state.getVendorPoTrendData = initialState.getVendorPoTrendData
    },
  },
})

export const { resetVendorPoData, resetVendorPoTrendData } = getVendorPoData.actions

export default getVendorPoData.reducer
